<template>
  <div></div>
</template>

<script>
import * as signalR from "@microsoft/signalr";

export default {
  name: "NotificationHub",
  props: {
    path: {
      type: String, 
      require: true
    }
  },
  data() {
    return {
      connection: null,
    };
  },
  methods: {
    async connectToHub() {
      if(!this.path || this.path.length <= 0) return;

      // Crear la conexión al hub
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(this.path, { withCredentials: false })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Warning)
        .build();

      // Manejo del evento "refresh" desde el hub
      this.connection.on("update", (message) => {
        // Emitir un evento personalizado al padre
        this.$emit("notification-received", message);
      });

      try {
        // Conectar al hub
        await this.connection.start();
        console.log("Conexión establecida con el hub.");
        this.$emit("connection-success");
      } catch (err) {
        console.error("Error al conectar al hub:", err);
        // Emitir un evento de error
        this.$emit("connection-error", err);
      }
    },
  },
  async mounted() {
    await this.connectToHub();
  },
  beforeDestroy() {
    if (this.connection) {
      this.connection.stop();
      console.log("Conexión detenida.");
    }
  },
};
</script>
